import fetchJSON from 'lib/fetchJSON'

export const receiveRides = (rides) => ({
  type: 'RECEIVE_RIDES',
  rides
})

export const loadUserReportsPage = userId => ({
  type: 'LOAD_REPORTS_PAGE',
  payload: fetchJSON(`/users/${userId}/reports_page.json`)
})

export const loadReportsPage = id => ({
  type: 'LOAD_REPORTS_PAGE',
  payload: fetchJSON(`/reports_pages/${id}.json`)
})

export const updateReportsPage = (id, attrs) => ({
  type: 'UPDATE_REPORTS_PAGE',
  payload: fetchJSON(`/reports_pages/${id}.json`, { reports_page: attrs }, { method: 'PATCH' })
})
